import { Helmet } from 'react-helmet-async';
import LandingHeader from '../landing/LandingHeader';
import LandingFooter from '../landing/LandingFooter';
import { IconQuestion } from '../landing/LandingIcons';

export default function PrivacyPolicy() {
    return (
        <>
            <Helmet>
                <title>개인정보처리방침 - GrowFit</title>
                <meta name="description" content="GrowFit 개인정보처리방침. 수집하는 개인정보 항목, 이용목적, 보유 및 이용기간 등을 안내합니다." />
                <link rel="canonical" href="https://growfit.kr/privacy" />
                <meta property="og:title" content="개인정보처리방침 - GrowFit" />
                <meta property="og:description" content="GrowFit 개인정보 수집·이용에 관한 안내." />
                <meta property="og:url" content="https://growfit.kr/privacy" />
                <meta property="og:type" content="website" />
            </Helmet>

            <div className="landing">
                <LandingHeader />

                <main className="landing__main landing__main--narrow" style={{ paddingTop: 40 }}>
                    <section className="landing-legal">
                        <div className="landing-legal__head">
                            <h1 className="landing-legal__title">개인정보처리방침</h1>
                            <span
                                className="landing-legal__help"
                                title="개인정보처리방침 안내"
                                aria-label="개인정보처리방침 안내"
                            >
                                <IconQuestion size={20} />
                            </span>
                        </div>

                        <div className="landing-legal__body">
                            <p className="landing-legal__meta">공고일자: 2025년 3월 5일 · 시행일자: 2025년 3월 5일</p>

                            <h2>1. 수집하는 개인정보의 항목 및 수집방법</h2>
                            <p><strong>가. 수집하는 개인정보의 항목</strong></p>
                            <p>GrowFit은 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수항목으로 수집하고 있습니다.</p>
                            <ul>
                                <li><strong>필수항목:</strong> 이름, 이메일, 비밀번호</li>
                                <li><strong>선택항목:</strong> 가입경로 (선택항목은 입력하지 않아도 회원가입이 가능합니다.)</li>
                            </ul>
                            <p>서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.</p>
                            <ul>
                                <li>IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
                            </ul>

                            <h2>2. 개인정보의 수집 및 이용목적</h2>
                            <p><strong>가. 회원관리</strong></p>
                            <p>회원제 서비스 제공, 개인식별, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 고지사항 전달, 회원탈퇴 의사의 확인, 접속빈도 파악, 회원의 서비스이용에 대한 통계</p>
                            <p><strong>나. AI 교육 서비스 제공</strong></p>
                            <p>AI 모델 실습 환경 제공, 프로젝트 관리, 지식베이스 활용, 학습 이력 관리, 강사-학생 매칭 및 수업 운영</p>

                            <h2>3. 개인정보의 공유 및 제공</h2>
                            <p>GrowFit은 이용자들의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                            <ul>
                                <li>이용자가 사전에 동의한 경우</li>
                                <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                            </ul>

                            <h2>4. 개인정보의 보유 및 이용기간</h2>
                            <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 보존 이유를 위해 명시한 기간 동안 보존합니다.</p>
                            <ul>
                                <li><strong>보존 항목:</strong> 이메일</li>
                                <li><strong>보존 이유:</strong> 부정 가입 및 이용 방지</li>
                                <li><strong>보존 기간:</strong> 1년</li>
                            </ul>

                            <h2>5. 개인정보 파기절차 및 방법</h2>
                            <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.</p>
                            <p><strong>가. 파기절차</strong></p>
                            <ul>
                                <li>이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후 파기됩니다.</li>
                                <li>동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
                            </ul>
                            <p><strong>나. 파기방법</strong></p>
                            <ul>
                                <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
                                <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                            </ul>

                            <h2>6. 이용자 및 법정대리인의 권리와 그 행사방법</h2>
                            <p>이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.</p>
                            <p>이용자의 개인정보 조회, 수정을 위해서는 '회원정보수정'을, 가입해지(동의철회)를 위해서는 '회원탈퇴'를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.</p>
                            <p>혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</p>

                            <h2>7. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h2>
                            <p><strong>가. 쿠키란?</strong></p>
                            <p>회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</p>
                            <p><strong>나. 쿠키 사용 목적</strong></p>
                            <p>이용자들이 방문한 GrowFit의 각 서비스와 웹 사이트들에 대한 방문, 이용자 규모 등을 파악하여 이용자에게 맞춤형 정보를 제공하기 위해 사용합니다.</p>
                            <p><strong>다. 쿠키의 설치/운영 및 거부</strong></p>
                            <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.</p>

                            <h2>8. 개인정보의 기술적/관리적 보호 대책</h2>
                            <p>GrowFit은 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.</p>
                            <p><strong>가. 비밀번호 암호화</strong></p>
                            <p>GrowFit 회원의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</p>
                            <p><strong>나. 해킹 등에 대비한 대책</strong></p>
                            <p>GrowFit은 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</p>

                            <h2>9. 개인정보관리책임자 및 담당자의 연락처</h2>
                            <p>귀하께서는 GrowFit의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.</p>
                            <ul>
                                <li><strong>개인정보 관리책임자 (정)</strong></li>
                                <li>이름: 박동민</li>
                                <li>소속: (주)비씨티원 (BCT ONE Inc.)</li>
                                <li>직위: 대표</li>
                            </ul>
                            <ul>
                                <li><strong>개인정보 관리책임자 (부)</strong></li>
                                <li>이름: 김동희</li>
                                <li>소속: (주)비씨티원 (BCT ONE Inc.)</li>
                            </ul>
                            <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                            <ul>
                                <li>개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                                <li>대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)</li>
                                <li>경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)</li>
                            </ul>

                            <h2>10. 기타</h2>
                            <p>GrowFit에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "GrowFit 개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>

                            <h2>11. 고지의 의무</h2>
                            <p>현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>
                            <p>- 공고일자: 2025년 3월 5일</p>
                            <p>- 시행일자: 2025년 3월 5일</p>
                        </div>
                    </section>
                </main>

                <LandingFooter />
            </div>
        </>
    );
}
